import { Chain } from "@webapp/shared";
import { FunctionComponent, SVGProps } from "react";

import {
  EthMainnetEmblem,
  ArbMainnetEmblem,
  PolygonMainnetEmblem,
  OptMainnetEmblem,
  SolanaMainnetEmblem,
  AstarMainnetEmblem,
  PolygonZkEvmMainnetEmblem,
  StarknetMainnetEmblem,
  BaseMainnetEmblem,
  ZkSyncMainnetEmblem,
  ZoraMainnetEmblem,
  FraxMainnetEmblem,
  BnbMainnetEmblem,
  AvaxMainnetEmblem,
  ArbNovaMainnetEmblem,
} from "@alch/ui/icons/networks";

/**
 * Round chain logo for each chain.
 *
 * This is in a separate file from constants.ts to improve tree shaking.
 */
const chainEmblems: Record<
  Chain,
  FunctionComponent<SVGProps<SVGSVGElement>>
> = {
  [Chain.ETH]: EthMainnetEmblem,
  [Chain.ARB]: ArbMainnetEmblem,
  [Chain.POLYGON]: PolygonMainnetEmblem,
  [Chain.OPT]: OptMainnetEmblem,
  [Chain.SOLANA]: SolanaMainnetEmblem,
  [Chain.ASTAR]: AstarMainnetEmblem,
  [Chain.POLYGONZKEVM]: PolygonZkEvmMainnetEmblem,
  [Chain.STARKNET]: StarknetMainnetEmblem,
  [Chain.BASE]: BaseMainnetEmblem,
  [Chain.ZKSYNC]: ZkSyncMainnetEmblem,
  [Chain.ZORA]: ZoraMainnetEmblem,
  [Chain.FRAX]: FraxMainnetEmblem,
  [Chain.BNB]: BnbMainnetEmblem,
  [Chain.AVAX]: AvaxMainnetEmblem,
  [Chain.ARBNOVA]: ArbNovaMainnetEmblem,
};

export default chainEmblems;
